import themeCategory from './theme-category'

export default {
  name: 'BaseInfoCms',
  path: 'cms',
  meta: {
    label: 'cms',
    auth: 'cms'
  },
  component: {
    name: 'Cms',
    render(c) {
      return c('router-view')
    }
  },
  children: [themeCategory]
}
